<app-layout>
    <div class="main-container" *ngIf="hasFeatureAccess">
        <nav class="menu" aria-label="Performance navigation">
            <mat-list class="navigation-menu-list" role="list">
                <ng-container *ngFor="let item of navList">
                    <mat-list-item 
                        setColor
                        [setColorRules]="[
                            {
                                color: 'primaryColour',
                                events: ['hover']
                            },
                            {
                                color: 'primaryColour',
                                setIfClass: ['primaryColor'],
                                events: ['routerLinkActive']
                            },
                        ]"
                        [routerLink]="item.link" 
                        routerLinkActive="primaryColor" 
                        #rla="routerLinkActive"
                        [attr.aria-current]="rla.isActive ? 'page' : null"
                        class="primaryHoverColor" 
                        *appHasFeature="item.featureCode"
                        role="listitem"
                    >
                        <mat-icon 
                            setColor
                            [setColorRules]="[
                                {
                                    color: 'primaryColour',
                                    events: ['hover']
                                },
                                {
                                    color: 'primaryColour',
                                    setIfClass: ['primaryColor'],
                                    events: ['routerLinkActive']
                                },
                            ]"
                            class="material-icons-outlined"
                            routerLinkActive="primaryColor"
                            aria-hidden="true"
                        >{{item.icon}}</mat-icon>
                        <div>{{item.text}}</div>
                    </mat-list-item>
                </ng-container>
            </mat-list>
        </nav>
        <div class="content">
            <div class="main-content">
                <ng-content></ng-content>
            </div>
        </div>
    </div>

    <no-feature-access *ngIf="!hasFeatureAccess"></no-feature-access>
</app-layout>
